import {H3Error} from 'h3';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (error: Error) => {
    const statusCode = error instanceof H3Error ? error.statusCode : 500;

    if (process.env.NODE_ENV === 'development') {
      console.error(error);
    }

    showError({statusCode, statusMessage: error.message});
  });
});
